<template>
    <a-dropdown placement="bottomRight">
        <span class="ant-pro-account-avatar">
            <a-avatar
              size="small"
              src="https://gw.alipayobjects.com/zos/antfincdn/XAosXuNZyF/BiazfanxmamNRoxxVxka.png"
                    class="antd-pro-global-header-index-avatar" />
            <span>{{ userName }}</span>
        </span>
        <template v-slot:overlay>
            <a-menu
                class="ant-pro-drop-down menu"
                :selected-keys="[]">
                <a-menu-item v-if="menu" key = "settings" @click="handleToSettings">
                    <a-icon type="setting" />
                    {{ $t('CHANGE_PASSWORD') || '修改密码'}}
                </a-menu-item>
                <a-menu-divider v-if="menu"/>
                <a-menu-item key="lauout" @click="handleLogout">
                    <a-icon type="layout"/>
                    {{ $t('LOGOUT' || '退出登录')}}
                </a-menu-item>
            </a-menu>
        </template>
    </a-dropdown>
</template>

<script>
import { Modal } from 'ant-design-vue';

export default {

  name: 'AvatarDropdown',
  data() {
    return {
      userName: this.$store.getters.getUserName(),
    };
  },
  methods: {
    handleToCenter() {
      this.$router.push({ path: '/account/center' });
    },
    handleToSettings() {
      this.$router.push({ path: '/account/settings' });
    },
    handleLogout() {
      Modal.confirm({
        title: this.$t('layouts.usermenu.dialog.title'),
        content: this.$t('layouts.usermenu.dialog.content'),
        onOk: () => {
          this.$store.commit('clearLoginInfo');
          this.$router.push({ path: 'login' });
        },
        onCancel() {
        },
      });
    },
  },
  props: {
    currentUser: {
      type: Object,
      default: () => null,
    },
    menu: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped>

</style>
